import { configureStore } from '@reduxjs/toolkit';

import { listenerMiddleware } from './listener';
import { reducer } from './reducer';
import { deviceSocketMiddleware } from './middleware/deviceSocketMiddleware';

const prod = __CI_BRANCH__ === 'master';

export const store = configureStore({
  reducer,
  devTools: !prod,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(listenerMiddleware.middleware).concat(deviceSocketMiddleware),
});
